import './search-result.scss'

import React from 'react'
import { Heading2 } from '@entur/typography'
import { Table, TableHead, TableRow, TableBody, HeaderCell, DataCell } from '@entur/table'
import { GridContainer, GridItem } from '@entur/grid'
import { SkeletonWrapper, SkeletonRectangle } from '@entur/loader'

const SearchResultLoader: React.FC = () => {
  return (
    <div>
      <GridContainer>
        <GridItem small={6}>
          <Heading2 className="search-result__header">
            <SkeletonWrapper>
              <SkeletonRectangle height="2.4rem" width="15rem" />
            </SkeletonWrapper>
          </Heading2>
        </GridItem>
        <GridItem small={6}>
          <SkeletonWrapper style={{ float: 'right', marginLeft: '1rem' }}>
            <SkeletonRectangle style={{ height: '2rem', width: '7.5rem' }} />
          </SkeletonWrapper>
          <SkeletonWrapper style={{ float: 'right' }}>
            <SkeletonRectangle style={{ height: '2rem', width: '10rem' }} />
          </SkeletonWrapper>
        </GridItem>
      </GridContainer>

      <SkeletonWrapper className="search-result__pagination">
        <GridContainer style={{ height: '2.3125rem' }}>
          <GridItem small={6}>
            <SkeletonRectangle height="2rem" width="18rem" />
          </GridItem>
          <GridItem small={6}>
            <SkeletonRectangle style={{ float: 'right', height: '2rem', width: '23rem' }} />
          </GridItem>
        </GridContainer>
      </SkeletonWrapper>

      <Table>
        <TableHead>
          <TableRow>
            <HeaderCell style={{ width: '30rem' }}>
              <SkeletonWrapper>
                <SkeletonRectangle width="9rem" />
              </SkeletonWrapper>
            </HeaderCell>
            <HeaderCell>
              <SkeletonWrapper>
                <SkeletonRectangle width="5rem" />
              </SkeletonWrapper>
            </HeaderCell>
            <HeaderCell>
              <SkeletonWrapper>
                <SkeletonRectangle width="6rem" />
              </SkeletonWrapper>
            </HeaderCell>
            <HeaderCell>
              <SkeletonWrapper>
                <SkeletonRectangle width="7rem" />
              </SkeletonWrapper>
            </HeaderCell>
            <HeaderCell>
              <SkeletonWrapper>
                <SkeletonRectangle width="5rem" />
              </SkeletonWrapper>
            </HeaderCell>
            <HeaderCell>
              <SkeletonWrapper>
                <SkeletonRectangle width="5rem" />
              </SkeletonWrapper>
            </HeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(10).keys()].map((id) => (
            <TableRow key={`skeleton-${id}`}>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="9rem" />
                </SkeletonWrapper>
              </DataCell>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="6rem" />
                </SkeletonWrapper>
              </DataCell>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="6rem" />
                </SkeletonWrapper>
              </DataCell>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="4rem" />
                </SkeletonWrapper>
              </DataCell>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="4rem" />
                </SkeletonWrapper>
              </DataCell>
              <DataCell>
                <SkeletonWrapper>
                  <SkeletonRectangle width="7rem" />
                </SkeletonWrapper>
              </DataCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default SearchResultLoader
